import { supabase } from "../../lib/supabaseClient";
import { UserProfile, UserRole } from "../types";

interface RawUserProfileRow {
  id: string;
  first_name: string | null;
  last_name: string | null;
  role: UserRole;
  created_at: string;
}

export async function fetchUserProfile(userId: string): Promise<UserProfile | null> {
  const { data, error } = await supabase
    .from("user_profiles")
    .select("id, first_name, last_name, role, created_at")
    .eq("id", userId)
    .single();

  if (error || !data) {
    return null;
  }

  const row = data as RawUserProfileRow;

  return {
    id: row.id,
    firstName: row.first_name,
    lastName: row.last_name,
    role: row.role,
    createdAt: row.created_at,
  };
}
